import React from "react";
import {Form} from "react-bootstrap";
import useSkFieldValidInvalid from "../useSkFieldValidInvalid";
import SkFieldProps from "./SkFieldProps";
import isSkFieldSubmitted from "./IsSkFieldSubmitted";
import SkFieldDescriptionBlock from "./SkFieldDescriptionBlock";
import SkFieldLabel from "./SkFieldLabel";

const SkFieldDate:React.FC<SkFieldProps> = (props) => {
  const {isInvalid, setReallyTouched} = useSkFieldValidInvalid(props);

  return (
    <Form.Group controlId={props.name}>
      <SkFieldLabel {...props}/>
      <Form.Control
        as={"input"}
        type="date"
        placeholder={"yyyy-mm-dd"}
        name={props.name}
        value={props.formikProps.values[props.name] || ""}
        onChange={props.formikProps.handleChange}
        isValid={isSkFieldSubmitted(props)}
        isInvalid={isInvalid}
        disabled={props.disabled || props.formikProps.isSubmitting}
        onBlur={() => setReallyTouched(true)}
      />
      <SkFieldDescriptionBlock
        description={props.description}
        isInvalid={isInvalid}
        errorText={`${props.formikProps.errors[props.name]}`}
      />
    </Form.Group>
  );
};

export default SkFieldDate;